import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import baseUrl from "../api/utils";
import { GlobalStateContext } from "../Context/GlobalStateProvider";
import undraw_profile from "../images/profile.png";
import RadialProgressBar from "./RadialProgressBar";
import SupportChart from "./SupportChart";
import FreeTrialUsage from "./FreeTrialUsage";

const Dashboard = () => {
  const navigate = useNavigate();
  const Currency = sessionStorage.getItem("Currency");
  const Role = sessionStorage.getItem("role");
  const MySwal = withReactContent(Swal);
  const token = sessionStorage.getItem("token");
  const { displayname } = useContext(GlobalStateContext);
  const [chartPeriod, setChartPeriod] = useState("thisMonth");
 const [chartData, setChartData] = useState({ categories: [], values: [] });

  const [storagedetail, setStoragedetail] = useState({ total: "", StorageUsed: "", balanceStorage: "" });

  // Renamed from countdetails (LMS) -> dashboardSummary (InvoiceBill)
  const [dashboardSummary, setDashboardSummary] = useState({
    totalSales: "",
    totalReceived: "",
    totalBalance: "",
    totalInvoices: "",
    newCustomers: "",
    totalItems: "",
    lowStockItems: "",
    thisMonthInvoices: "",
    newCustomersThisMonth: "",
  });

  // Renamed from trainerFest -> recentInvoices
  const [recentInvoices, setRecentInvoices] = useState([
    { invoiceNo: "", customerName: "", type: "", date: "", amount: "", status: "" },
  ]);

  // Renamed from StudentFest -> topCustomers
  const [topCustomers, setTopCustomers] = useState([
    { name: "", profile: null, totalSales: "" },
  ]);

  const [StudentFestSysAdmin, setStudentFestSysAdmin] = useState([{ name: "", batchName: "", courseName: "", amount: "" }]);
  const [selectedInstitution, setSelectedInstitution] = useState("");
  const [institutionNames, setInstitutionNames] = useState([]);

   useEffect(() => {
  if (Role !== "ADMIN"  && Role !== "CASHIER") return;
  const fetchAll = async () => {
    try {
      const [summary, recentInv, topCust] = await Promise.all([
        axios.get(`${baseUrl}/dashboard/summary`, { headers: { Authorization: token } }),
        axios.get(`${baseUrl}/dashboard/recentInvoices`, { headers: { Authorization: token } }),
        axios.get(`${baseUrl}/dashboard/topCustomers`, { headers: { Authorization: token } }),
      ]);
      if (summary.status === 200) setDashboardSummary(summary.data);
      setRecentInvoices(recentInv.data);
      setTopCustomers(topCust.data);
    } catch (error) {
      if (error.response?.status === 401) navigate("/unauthorized");
      else console.error("Dashboard fetch failed:", error);
    }
  };
  fetchAll();
}, []);


// ═══════════════════════════════════════════════════════════════════════════════
// ADD THIS INTO Dashboard.jsx
// ═══════════════════════════════════════════════════════════════════════════════
//
// 1. Nothing new to import — this file already imports axios, baseUrl, Swal,
//    withReactContent, and already defines `MySwal`, `token`, `Role` at the top.
//
// 2. Paste this new useEffect block anywhere alongside your other useEffects
//    inside the Dashboard component (e.g. right after the `fetchAll` useEffect).
// ═══════════════════════════════════════════════════════════════════════════════

useEffect(() => {
  if (Role !== "ADMIN" && Role !== "CASHIER") return;

  let timer;

  const checkLicenseNotification = async () => {
    try {
      const res = await axios.get(`${baseUrl}/api/v2/license/notification`, {
        headers: { Authorization: token },
      });
      const { expiring, expired, message } = res.data;
      if ((expiring || expired) && message) {
        MySwal.fire({
          icon: expired ? "error" : "warning",
          title: expired ? "License Expired" : "License Expiring Soon",
          text: message,
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("License notification check failed:", error);
    }
  };

  const setupSchedule = async () => {
    try {
      const settingsRes = await axios.get(`${baseUrl}/api/v2/license/notification-settings`, {
        headers: { Authorization: token },
      });
      const { intervalHours, isActive } = settingsRes.data;
      if (!isActive) return;

      // show once right away on login/mount, then repeat every intervalHours while the tab stays open
      checkLicenseNotification();
      timer = setInterval(checkLicenseNotification, intervalHours * 60 * 60 * 1000);
    } catch (error) {
      console.error("Failed to load notification schedule:", error);
    }
  };

  setupSchedule();

  // cleanup: stop the interval if the component unmounts (e.g. user navigates away or logs out)
  return () => {
    if (timer) clearInterval(timer);
  };
}, []);


  useEffect(() => {
  if (Role !== "ADMIN"  && Role !== "CASHIER") return;
  const fetchTrend = async () => {
    try {
      const res = await axios.get(`${baseUrl}/dashboard/salesTrend`, {
        headers: { Authorization: token },
        params: { period: chartPeriod },
      });
      if (res.status === 200) {
        setChartData({
          categories: res.data.categories,
          values: res.data.values,
        });
      }
    } catch (error) {
      if (error.response?.status === 401) navigate("/unauthorized");
      else console.error("Sales trend fetch failed:", error);
    }
  };
  fetchTrend();
}, [chartPeriod]);

  // useEffect(() => {
  //   if (Role !== "SYSADMIN") return;
  //   const fetchSysAdmin = async () => {
  //     try {
  //       const url = selectedInstitution === "*" || selectedInstitution === ""
  //         ? `${baseUrl}/sysadmin/dashboard`
  //         : `${baseUrl}/sysadmin/dashboard/${selectedInstitution}`;
  //       const [dash, adminsRes] = await Promise.all([
  //         axios.get(url, { headers: { Authorization: token } }),
  //         axios.get(`${baseUrl}/ViewAll/Admins`, { headers: { Authorization: token } }),
  //       ]);
  //       if (dash.status === 200) {
  //         setDashboardSummary(dash.data.paymentsummary || {});
  //         setStudentFestSysAdmin(dash.data.paymentlist || []);
  //       }
  //       if (adminsRes.data?.content) {
  //         const adminData = adminsRes.data.content;
  //         const names = Array.from(new Set(adminData.map((a) => a.companyName).filter(Boolean)));
  //         setInstitutionNames(names);
  //         if (names.length === 1) setSelectedInstitution("*");
  //       }
  //     } catch (error) {
  //       if (error.response?.status === 401) navigate("/unauthorized");
  //       else throw error;
  //     }
  //   };
  //   fetchSysAdmin();
  // }, [selectedInstitution]);

  const convertToGB = (value) => {
    if (!value) return 0;
    if (value.toLowerCase().includes("mb")) return parseFloat(value) / 1024;
    if (value.toLowerCase().includes("gb")) return parseFloat(value);
    return 0;
  };
  const usedPercentage = (convertToGB(storagedetail.StorageUsed) / convertToGB(storagedetail.total)) * 100;
  const currencyIcon = Currency === "INR" ? "fa-indian-rupee-sign" : "fa-dollar-sign";

  // ── ADMIN DASHBOARD ──
  if (Role !== "SYSADMIN") {
    return (
      <>
        {/* Page Header */}
        <div className="page-header">
          <div className="page-block">
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="page-header-title">
                  <h5 className="m-b-10">Dashboard</h5>
                </div>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#" onClick={() => navigate("/admin/dashboard")}>
                      <i className="feather icon-home"></i>
                    </a>
                  </li>
                  <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="inv-dash-wrapper">
       
          {/* ── TOP KPI STRIP (5 cards) ── */}
          <div className="inv-kpi-strip">

          <div
            className="inv-kpi-card"
            onClick={() => navigate("/view/salesinvoice")}
            style={{ display: "flex", alignItems: "center", minHeight: "100px", padding: "16px", gap: "12px" }}
          >
            <div className="inv-kpi-icon yellow">
              <i className="feather icon-shopping-cart"></i>
            </div>
            <div style={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
              <div
                className="inv-kpi-num"
                style={{
                  fontSize: "1.4rem",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  lineHeight: 1,
                  marginTop: "15px",
                }}
              >
                {currencyIcon === "fa-indian-rupee-sign" ? "₹" : "$"}{dashboardSummary.totalSales || 0}
              </div>
              <div className="inv-kpi-label" style={{ fontSize: "0.75rem", whiteSpace: "nowrap" }}>
                Total Sales
              </div>
            </div>
            <span className="inv-kpi-badge yellow" style={{ flexShrink: 0, whiteSpace: "nowrap" }}>
              this month
            </span>
          </div>

          <div
            className="inv-kpi-card"
            onClick={() => navigate("/view/Payments")}
            style={{ display: "flex", alignItems: "center", minHeight: "100px", padding: "16px", gap: "12px" }}
          >
            <div className="inv-kpi-icon green">
              <i className="feather icon-credit-card"></i>
            </div>
            <div style={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
              <div
                className="inv-kpi-num"
                style={{
                  fontSize: "1.4rem",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  lineHeight: 1,
                  marginTop: "15px",
                }}
              >
                {currencyIcon === "fa-indian-rupee-sign" ? "₹" : "$"}{dashboardSummary.totalReceived || 0}
              </div>
              <div className="inv-kpi-label" style={{ fontSize: "0.75rem", whiteSpace: "nowrap" }}>
                Total Received
              </div>
            </div>
            <span className="inv-kpi-badge green" style={{ flexShrink: 0, whiteSpace: "nowrap" }}>
              received
            </span>
          </div>

          <div
            className="inv-kpi-card"
            style={{ display: "flex", alignItems: "center", minHeight: "100px", padding: "16px", gap: "12px" }}
          >
            <div className="inv-kpi-icon dark">
              <i className="feather icon-briefcase"></i>
            </div>
            <div style={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
              <div
                className="inv-kpi-num"
                style={{
                  fontSize: "1.4rem",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  lineHeight: 1,
                  marginTop: "15px",
                }}
              >
                {currencyIcon === "fa-indian-rupee-sign" ? "₹" : "$"}{dashboardSummary.totalBalance || 0}
              </div>
              <div className="inv-kpi-label" style={{ fontSize: "0.75rem", whiteSpace: "nowrap" }}>
                Total Balance
              </div>
            </div>
            <span className="inv-kpi-badge dark" style={{ flexShrink: 0, whiteSpace: "nowrap" }}>
              due
            </span>
          </div>

          <div
            className="inv-kpi-card"
            onClick={() => navigate("/view/salesinvoice")}
            style={{ display: "flex", alignItems: "center", minHeight: "100px", padding: "16px", gap: "12px" }}
          >
            <div className="inv-kpi-icon red">
              <i className="feather icon-file-text"></i>
            </div>
            <div style={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
              <div
                className="inv-kpi-num"
                style={{
                  fontSize: "1.4rem",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  lineHeight: 1,
                  marginTop: "15px",
                }}
              >
                {dashboardSummary.totalInvoices || 0}
              </div>
              <div className="inv-kpi-label" style={{ fontSize: "0.75rem", whiteSpace: "nowrap" }}>
                Total Invoices
              </div>
            </div>
            <span className="inv-kpi-badge red" style={{ flexShrink: 0, whiteSpace: "nowrap" }}>
              total
            </span>
          </div>

          <div
            className="inv-kpi-card inv-kpi-dark"
            onClick={() => navigate("/view/suppliers")}
            style={{ display: "flex", alignItems: "center", minHeight: "100px", padding: "16px", gap: "12px" }}
          >
            <div className="inv-kpi-icon white">
              <i className="feather icon-users"></i>
            </div>
            <div style={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
              <div
                className="inv-kpi-num"
                style={{
                  fontSize: "1.4rem",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  lineHeight: 1,
                  marginTop: "15px",
                }}
              >
                {dashboardSummary.newCustomers || 0}
              </div>
              <div className="inv-kpi-label" style={{ fontSize: "0.75rem", whiteSpace: "nowrap" }}>
                Total Customers
              </div>
            </div>
            <span className="inv-kpi-badge blue" style={{ flexShrink: 0, whiteSpace: "nowrap" }}>
              Total
            </span>
          </div>

        </div>
          {/* ── MAIN GRID (Chart) ── */}
          <div className="inv-main-grid">

            <div className="inv-card span-2">
              <div className="inv-card-header">
                <div>
                  <div className="inv-card-title">Sales Overview</div>
                  <div className="inv-card-sub">Invoice sales trends</div>
                </div>
                <select
                  value={chartPeriod}
                  onChange={(e) => setChartPeriod(e.target.value)}
                  style={{ padding: "6px 10px", borderRadius: "6px", border: "1px solid #ddd" }}
                >
                  <option value="thisMonth">This Month</option>
                  <option value="lastMonth">Last Month</option>
                  <option value="thisYear">This Year</option>
                </select>
              </div>
              <SupportChart data={chartData.values} categories={chartData.categories} />
              <div className="inv-chart-footer">
                <div className="inv-chart-stat"><span className="inv-dot yellow"></span>{dashboardSummary.totalReceived || 0} Received</div>
                <div className="inv-chart-stat"><span className="inv-dot green"></span>{dashboardSummary.totalInvoices || 0} Invoices</div>
                <div className="inv-chart-stat"><span className="inv-dot dark"></span>{dashboardSummary.totalSales || 0} Sales</div>
              </div>
            </div>

            {/* Storage block left commented as-is */}
            {/* <div className="inv-card">
              ...
            </div> */}

          </div>

          {/* ── TABLES ── */}
          <div className="inv-table-grid">

            {/* Recent Invoices (was Trainers/Parties) */}
            <div className="inv-card">
              <div className="inv-card-header">
                <div>
                  <div className="inv-card-title">Recent Invoices</div>
                  <div className="inv-card-sub">Latest 5 sale invoices</div>
                </div>
                <button className="inv-view-btn" onClick={() => navigate("/view/salesinvoice")}>View all</button>
              </div>
              <div className="inv-table-scroll">
                <table className="inv-table">
                  <thead>
                  <tr>
                    <th>Invoice No.</th>
                    <th>Type</th>
                    <th>Customer Name</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {recentInvoices.map((inv, i) => (
                    <tr key={i}>
                      <td>{inv.invoiceNo || "—"}</td>
                      <td>{inv.type || "—"}</td>
                      <td>
                        <div className="inv-name-cell">
                          <span>{inv.customerName || "—"}</span>
                        </div>
                      </td>
                      <td><span className="inv-badge dark">{inv.amount || 0}</span></td>
                      <td>
                        <span className={`inv-badge ${inv.status === "Paid" ? "green" : "red"}`}>
                          {inv.status || "—"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
                </table>
              </div>
            </div>

            {/* Top Customers (was Students) */}
            <div className="inv-card">
              <div className="inv-card-header">
                <div>
                  <div className="inv-card-title">Top Customers</div>
                  <div className="inv-card-sub">Highest 5 sales by customer</div>
                </div>
                <button className="inv-view-btn" onClick={() => navigate("/view/suppliers")}>View all</button>
              </div>
              <div className="inv-table-scroll">
                <table className="inv-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Total Sales</th>
                    </tr>
                  </thead>
                  <tbody>
                    {topCustomers.map((c, i) => (
                    <tr key={i}>
                      <td>
                        <div className="inv-name-cell">
                          <img src={undraw_profile} alt="customer" className="inv-avatar" />
                          <span>{c.customerName || "—"}</span>
                        </div>
                      </td>
                      <td><span className="inv-badge green">{c.totalSales || 0}</span></td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              </div>
            </div>

          </div>

        </div>

        {/* ── BOTTOM KPI STRIP (4 cards) ── */}
        <div className="inv-kpi-strip">

          <div className="inv-kpi-card" onClick={() => navigate("/dashboard/viewitem")}>
            <div className="inv-kpi-icon yellow">
              <i className="feather icon-box"></i>
            </div>
            <div>
              <div className="inv-kpi-num">{dashboardSummary.totalItems || 0}</div>
              <div className="inv-kpi-label">Total Items</div>
            </div>
            <span className="inv-kpi-badge yellow">total</span>
          </div>

          <div className="inv-kpi-card" onClick={() => navigate("/dashboard/viewitem")}>
            <div className="inv-kpi-icon red">
              <i className="feather icon-alert-triangle"></i>
            </div>
            <div>
              <div className="inv-kpi-num">{dashboardSummary.lowStockItems || 0}</div>
              <div className="inv-kpi-label">Total Lowstock Items</div>
            </div>
            <span className="inv-kpi-badge red">low stock</span>
          </div>

          <div className="inv-kpi-card" onClick={() => navigate("/view/salesinvoice")}>
            <div className="inv-kpi-icon dark">
              <i className="feather icon-file-text"></i>
            </div>
            <div>
              <div className="inv-kpi-num">{dashboardSummary.thisMonthInvoices || 0}</div>
              <div className="inv-kpi-label">This Month Invoice</div>
            </div>
            <span className="inv-kpi-badge dark">total</span>
          </div>

          <div className="inv-kpi-card" onClick={() => navigate("/view/suppliers")}>
            <div className="inv-kpi-icon green">
              <i className="feather icon-user-plus"></i>
            </div>
            <div>
              <div className="inv-kpi-num">{dashboardSummary.newCustomersThisMonth || 0}</div>
              <div className="inv-kpi-label">New Customer</div>
            </div>
            <span className="inv-kpi-badge green">this month</span>
          </div>

        </div>
      </>
    );
  }

  // ── SYSADMIN DASHBOARD (unchanged structure, left as-is) ──
  return (
    <>
      <div className="page-header">
        <div className="page-block">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="page-header-title d-flex align-items-center justify-content-between">
                <h5 className="m-b-10">Dashboard</h5>
                {institutionNames.length > 1 && (
                  <select value={selectedInstitution} onChange={(e) => setSelectedInstitution(e.target.value)}
                    className="form-control" style={{ maxWidth: 250, color: "#000", backgroundColor: "#fff" }}>
                    <option value="*">All Institutions</option>
                    {institutionNames.map((inst, i) => <option key={i} value={inst}>{inst}</option>)}
                  </select>
                )}
              </div>
              <ul className="breadcrumb">
                <li className="breadcrumb-item"><a href="#" onClick={() => navigate("/admin/dashboard")}><i className="feather icon-home"></i></a></li>
                <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="inv-dash-wrapper">

        <div className="inv-kpi-strip">
          <div className="inv-kpi-card">
            <div className="inv-kpi-icon yellow"><i className="feather icon-file-text"></i></div>
            <div>
              <div className="inv-kpi-num">{dashboardSummary.totalInvoices || 0}</div>
              <div className="inv-kpi-label">Invoices</div>
            </div>
          </div>
          <div className="inv-kpi-card">
            <div className="inv-kpi-icon red"><i className="feather icon-users"></i></div>
            <div>
              <div className="inv-kpi-num">{dashboardSummary.newCustomers || 0}</div>
              <div className="inv-kpi-label">Customers</div>
            </div>
          </div>
          <div className="inv-kpi-card">
            <div className="inv-kpi-icon dark"><i className="feather icon-box"></i></div>
            <div>
              <div className="inv-kpi-num">{dashboardSummary.totalItems || 0}</div>
              <div className="inv-kpi-label">Items</div>
            </div>
          </div>
          <div className="inv-kpi-card inv-kpi-dark">
            <div className="inv-kpi-icon white"><i className={`fa-solid ${currencyIcon}`}></i></div>
            <div>
              <div className="inv-kpi-num">{dashboardSummary.totalReceived || 0}</div>
              <div className="inv-kpi-label">Revenue</div>
            </div>
          </div>
        </div>

        <div className="inv-card" style={{ marginBottom: 24 }}>
          <div className="inv-card-header">
            <div>
              <div className="inv-card-title">Revenue Overview</div>
              <div className="inv-card-sub">Payment trends across companies</div>
            </div>
          </div>
          <SupportChart data={[0, dashboardSummary.totalReceived, dashboardSummary.totalInvoices, dashboardSummary.totalSales, 0]} />
          <div className="inv-chart-footer">
            <div className="inv-chart-stat"><span className="inv-dot yellow"></span>{dashboardSummary.totalReceived || 0} Received</div>
            <div className="inv-chart-stat"><span className="inv-dot green"></span>{dashboardSummary.totalInvoices || 0} Invoices</div>
            <div className="inv-chart-stat"><span className="inv-dot dark"></span>{dashboardSummary.totalSales || 0} Sales</div>
          </div>
        </div>

        <div className="inv-card">
          <div className="inv-card-header">
            <div>
              <div className="inv-card-title">Recent Payments</div>
              <div className="inv-card-sub">Customer payment records</div>
            </div>
          </div>
          <div className="inv-table-scroll">
            <table className="inv-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Invoice No.</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {StudentFestSysAdmin.map((s, i) => (
                  <tr key={i}>
                    <td>
                      <div className="inv-name-cell">
                        <img src={s.profile ? `data:image/jpeg;base64,${s.profile}` : undraw_profile} alt="customer" className="inv-avatar" />
                        <span>{s.name || "—"}</span>
                      </div>
                    </td>
                    <td>{s.batchName || "—"}</td>
                    <td><span className="inv-badge green">{s.amount || 0}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </>
  );
};

export default Dashboard;